import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Menus - Table Tent - INGAZ Print";

function MenusTent() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          {/* Product Details Section */}
          <section className="product-details-section">
            <div className="product-container">
              {/* Left: Product Image Gallery */}
              <ProductGallery alt="Menus - Table Tent" images={[asset('assets/menus_tent.png'), asset('assets/menus_tent_angle.png'), asset('assets/menus_tent_detail.png'), asset('assets/menus_tent_var.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Menus - Table Tent" data-ar="القوائم">Menus - Table Tent</h1>
                <p className="product-description" data-en="Professional restaurant menus with high-quality printing and binding options." data-ar="قوائم مطاعم احترافية مع طباعة عالية الجودة وخيارات تجليد متنوعة.">Professional restaurant menus
                  with high-quality printing and binding options.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Durable materials resistant to spills and wear" data-ar="مواد متينة مقاومة للسوائل والاهتراء">
                      Durable materials resistant to spills and wear</li>
                    <li data-en="Vibrant color printing makes food look appetizing" data-ar="طباعة ألوان زاهية تجعل الطعام يبدو شهياً">
                      Vibrant color printing makes food look appetizing</li>
                    <li data-en="Variety of sizes and folding options" data-ar="مجموعة متنوعة من الأحجام وخيارات الطي">
                      Variety of sizes and folding options</li>
                    <li data-en="Easy to clean and maintain" data-ar="سهل التنظيف والصيانة">
                      Easy to clean and maintain</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Dine-in Menus" data-ar="قوائم المطاعم">Dine-in Menus</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/truck.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Takeout Menus" data-ar="قوائم التيك أواي">Takeout Menus</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Drink Specials" data-ar="عروض المشروبات">Drink Specials</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/location-dark.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Cafe Lists" data-ar="قوائم المقاهي">Cafe Lists</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          {/* Configuration Section */}
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Menus – Table Tent" data-ar="قم بتكوين القوائم – خيمة الطاولة">Configure Your Menus – Table Tent</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={50} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Format */}
                <div className="config-group">
                  <label data-en="Format" data-ar="الشكل">Format</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="format" defaultValue="a-frame" defaultChecked /><span>A-Frame / Tent fold (2 panels, prints on both outer faces)</span></label>
                    <label className="radio-option"><input type="radio" name="format" defaultValue="triangle" /><span>Triangle / Prism fold (3 panels, prints on all 3 faces)</span></label>
                    <label className="radio-option"><input type="radio" name="format" defaultValue="flat-stand" /><span>Flat card with separate stand (<a href="/indoor-signage" style={{textDecoration: 'underline', color: 'var(--accent-color, #007bff)'}}>use Indoor Signage form for the stand</a>)</span></label>
                  </div>
                </div>
                {/* Flat (unfolded) Size */}
                <div className="config-group">
                  <label data-en="Flat (unfolded) Size" data-ar="الحجم المسطح (غير المطوي)">Flat (unfolded) Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="A4" data-dims="297x210"><span>A4</span><br /><span>297×210 mm (folds to A5 tent)</span></div>
                    <div className="size-option" data-size="A5" data-dims="210x148"><span>A5</span><br /><span>210×148 mm (folds to A6 tent)</span></div>
                    <div className="size-option" data-size="DL" data-dims="210x99"><span>DL</span><br /><span>210×99 mm (folds to 1/3 A4 tent)</span></div>
                    <div className="size-option" data-size="297x140" data-dims="297x140"><span>297×140 mm</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Custom" data-ar="مخصص">Custom</span><br /><span data-en="L × W" data-ar="الطول × العرض">L × W</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="couche-350">Couche 350 gsm</option>
                      <option value="couche-300">Couche 300 gsm</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printed Colors */}
                <div className="config-group">
                  <label data-en="Printed Colors" data-ar="الألوان المطبوعة">Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots"><span className="dot red" /><span className="dot green" /><span className="dot blue" /></div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <div className="color-dots"><span className="dot black" /><span className="dot white" /></div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>
                {/* Printing Sides */}
                <div className="config-group">
                  <label data-en="Printing Sides" data-ar="جوانب الطباعة">Printing Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single"><img src={asset('assets/paperside.svg')} alt="" /><span>One side only</span></div>
                  </div>
                </div>
                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="none" defaultChecked /><span>None</span></label>
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="matt-one" /><span>Matt Cellophane [One side]</span></label>
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="matt-both" /><span>Matt Cellophane [Both sides]</span></label>
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="gloss-one" /><span>Gloss Cellophane [One side]</span></label>
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="gloss-both" /><span>Gloss Cellophane [Both sides]</span></label>
                  </div>
                </div>
                {/* Finishing */}
                <div className="config-group">
                  <label data-en="Finishing" data-ar="التشطيب">Finishing</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="finishing" defaultValue="creasing" defaultChecked /><span data-en="Creasing" data-ar="تجعيد">Creasing</span></label>
                    <label className="radio-option"><input type="radio" name="finishing" defaultValue="pre-folded" /><span data-en="Pre-folded and assembled" data-ar="مطوية ومجمعة مسبقاً">Pre-folded and assembled</span></label>
                    <label className="radio-option"><input type="radio" name="finishing" defaultValue="self-adhesive" /><span data-en="Self-adhesive tab for assembly" data-ar="لسان لاصق للتجميع">Self-adhesive tab for assembly</span></label>
                    <label className="radio-option"><input type="radio" name="finishing" defaultValue="none" /><span data-en="None" data-ar="لا شيء">None</span></label>
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} defaultValue={""} />
                </div>
                {/* Upload Artwork */}
                <div className="config-group">
                  <label data-en="Upload Artwork" data-ar="رفع التصميم">Upload Artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p>Drop your files here or browse</p>
                      <p className="upload-hint">Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item"><span className="summary-label">Format:</span><span className="summary-value" id="summaryFormat">A-Frame / Tent fold</span></div>
                  <div className="summary-item"><span className="summary-label">Size:</span><span className="summary-value" id="summarySize">A4</span></div>
                  <div className="summary-item"><span className="summary-label">Paper:</span><span className="summary-value" id="summaryPaper">Couche 350 gsm</span></div>
                  <div className="summary-item"><span className="summary-label">Color:</span><span className="summary-value" id="summaryColor">Full Color</span></div>
                  <div className="summary-item"><span className="summary-label">Lamination:</span><span className="summary-value" id="summaryLamination">None</span></div>
                  <div className="summary-item"><span className="summary-label">Finishing:</span><span className="summary-value" id="summaryFinishing">Creasing</span></div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time">1-3 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item">✓ Free design review</div>
                  <div className="guarantee-item">✓ Quality guarantee</div>
                  <div className="guarantee-item">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus - Table Tent" />
                  </div>
                  <h3 data-en="Menus - Table Tent" data-ar="القوائم">Menus - Table Tent</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default MenusTent;

